import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { mountStoreDevtool } from "simple-zustand-devtools";

interface loginStore {
  emailAddress: string;
  isCodeSent: boolean;
  verificationCodeSentTo: string;
  ttoken: string;
  vtoken: string;
  isLoggedIn: boolean;
  isAccountApproved: boolean; // <-- add this line
  addEmail: (email: string) => void;
  addCodeSent: (isCodeSent: boolean) => void;
  verificationCodeSentToPhone: (phone: string) => void;
  logIn: (tokens) => void;
  logOut: () => void;
}
//TODO testing value below
const useLoginStore = create<loginStore>()(
  persist(
    (set) => ({
      emailAddress: null, // "",
      isCodeSent: false, // false,
      verificationCodeSentTo: null,
      ttoken: null,
      vtoken: null,
      isLoggedIn: false, // false,
      isAccountApproved: false, // <-- add this line
      addEmail: (email) => set(() => ({ emailAddress: email })),
      addCodeSent: (codeSent) => set({ isCodeSent: codeSent }),
      verificationCodeSentToPhone: (phone) => set({ verificationCodeSentTo: phone }),
      logIn: (tokens) =>
        set({
          ttoken: tokens.ttoken,
          vtoken: tokens.vtoken,
          isLoggedIn: tokens.isLoggedIn,
          isAccountApproved: tokens.isAccountApproved, // <-- add this line
        }),
      logOut: () =>
        set({
          ttoken: null,
          vtoken: null,
          isCodeSent: false,
          isLoggedIn: false,
          isAccountApproved: false, // <-- add this line
        }),
    }),
    {
      name: "tg-user",
      storage: createJSONStorage(() => localStorage),
    }
  )
);

if (process.env.NODE_ENV === "development") mountStoreDevtool("Login Store", useLoginStore);
export default useLoginStore;
